<template>
  <Alert type="warning" class="auth-alert">
    <template #icon>
      <AuthorizationDifferences>
        <div class="auth-alert__icon-wrapper">
          <IconCircleWarning class="auth-alert__icon" />
        </div>
      </AuthorizationDifferences>
    </template>
    <div class="auth-alert__content">
      <div class="auth-alert__left">
        <span class="auth-alert__title">{{ $t('ge-ren-shang-yong-shou-quan') }}</span>
        <span class="auth-alert__desc">
          {{ $t('jin-xian-ge-ren-shi-yong-bu-ke-yong-yu-qi-ye-shang-ye-huo-dong') }}
        </span>
      </div>
      <div
        class="auth-alert__button"
        :class="{ 'alert__clickable-link': true }"
        variant="warning"
        size="compact"
        @click="handleBuyEnterprisePackage"
      >
        {{ $t('wo-yao-gou-mai-qi-ye-shang-yong-tao-can') }}
        <IconArrow class="icon-arrow"></IconArrow>
      </div>
    </div>
  </Alert>
</template>

<script setup lang="ts">
import { getI18nService } from '@rendora/common/services/i18n';
import IconArrow from '@rendora/design/assets/arrow.svg?component';
import IconCircleWarning from '@rendora/design/assets/circle-warning.svg?component';
import { Alert } from '@rendora/design/components/alert/index';
import { Preference } from '../../../store';
import AuthorizationDifferences from '../../AuthorizationDifferences.vue';
import { showRightCompareModal } from '../../right-compare/index';

const i18nService = getI18nService();
const $t = i18nService.t;

function handleBuyEnterprisePackage() {
  showRightCompareModal(Preference.ENTERPRISE);
}
</script>

<style lang="scss" scoped>
.auth-alert {
  margin-bottom: 0;
}

.auth-alert__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.auth-alert__left {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

.auth-alert__title {
  font-size: var(--x-text-12-size);
  line-height: var(--x-text-12-line-height);
  color: var(--x-warning-7);
}

.auth-alert__icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  transform: translateY(3px);
}

.auth-alert__icon {
  width: 16px;
  height: 16px;
  color: var(--x-warning-6);
}

.auth-alert__desc {
  color: var(--x-text-3);
  font-size: 12px;
}

.auth-alert__button {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: var(--x-text-12-size);
  line-height: var(--x-text-12-line-height);
  color: var(--x-warning-9);
}

.icon-arrow {
  height: 16px;
  width: 16px;
}

.alert__clickable-link {
  color: var(--x-warning-9);
  cursor: pointer;
  &:hover {
    color: var(--x-warning-8);
  }
}
</style>
